import type { SVGProps } from 'react';
const SvgPriorityHigh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#priority_high_svg__a)">
      <path d="M12 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM10 3h4v12h-4V3Z" />
    </g>
    <defs>
      <clipPath id="priority_high_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPriorityHigh;
